const config = {
  API_URL: 'https://local-api.getsling.com/v1/',
  APP_URL: 'https://local-app.getsling.com/',
  INTEGRATIONS_PAGE_URL: 'http://local-app.getsling.com/settings?tab=integrations',
  AUTHORIZATION_COOKIE: 'local:authorization-token',
  LOGIN_PAGE_URL: 'http://local-login.getsling.com',
  SIGNUP_PAGE_URL: 'http://local-login.getsling.com/register',
  SHOPIFY_API_KEY: 'f4148857cb0c9224e59972a15b1cc2c2',
  TOAST_SLING_CONNECT_URL:
    'https://preprod.eng.toasttab.com/restaurants/admin/scheduling/sling/connect',
};
export default config;
